import React from "react";

const LogoLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-secondary z-50">
      <div className="relative w-72 h-72">
        {/* Glowing aura behind the logo */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-[#F1E5AC] via-[#FFD700] to-primary blur-xl opacity-60 animate-ping"></div>

        {/* Spinning light ring */}
        <div className="absolute inset-0 rounded-full border-[6px] border-dashed border-primary animate-spin-slow"></div>

        {/* Main Logo in center */}
        <img
          src="/Logo.png"
          alt="Loading..."
          className="absolute top-1/2 left-1/2 w-32 h-32 -translate-x-1/2 -translate-y-1/2 object-contain z-10"
        />
      </div>
    </div>
  );
};

export default LogoLoader;
